import { render } from "./teacher.vue?vue&type=template&id=b722a47c&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"

import "./teacher.vue?vue&type=style&index=0&id=b722a47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b722a47c"]])

export default __exports__